import { render, staticRenderFns } from "./crudServices.vue?vue&type=template&id=102a53a0&scoped=true&"
import script from "./crudServices.vue?vue&type=script&lang=js&"
export * from "./crudServices.vue?vue&type=script&lang=js&"
import style0 from "./crudServices.vue?vue&type=style&index=0&lang=css&"
import style1 from "./crudServices.vue?vue&type=style&index=1&id=102a53a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "102a53a0",
  null
  
)

export default component.exports